import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { inverterInfo, itemParam, ListResponse } from 'models';

export interface InveterState {
  loading: boolean;
  currentInverter?: inverterInfo;
  error?: string;
  inverterList?: ListResponse<inverterInfo>;
  colorList: string[];
}

const initialState: InveterState = {
  loading: false,
  currentInverter: undefined,
  error: undefined,
  inverterList: undefined,
  colorList: [
    '#E11D48',
    '#0284C7',
    '#059669',
    '#FB7185',
    '#A21CAF',
    '#4338CA',
    '#60A5FA',
    '#164E63',
    '#2DD4BF',
    '#365314',
    '#CA8A04',
    '#FACC15',
    '#EA580C',
    '#F97316',
    '#7F1D1D',
    '#44403C',
    '#A3A3A3',
    '#0F172A',
    '#64748B',
    '#FB923C',
  ],
};

const inverterSlice = createSlice({
  name: 'inverter',
  initialState,
  reducers: {
    fetchInverterList(state, action: PayloadAction<itemParam>) {
      state.loading = true;
    },
    fetchInvertersSuccess(state, action: PayloadAction<ListResponse<inverterInfo>>) {
      state.loading = false;
      state.inverterList = action.payload;
    },
    fetchInverterFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteInverterById(state, action: PayloadAction<string>) {
      state.loading = true;
    },
    fetchInverterInfo(state, action: PayloadAction<inverterInfo>) {
      state.loading = true;
    },
    fetchInverterInfoSuccess(state, action: PayloadAction<inverterInfo>) {
      state.loading = false;
      state.currentInverter = action.payload;
    },
    // deleteInverterById(state, action: PayloadAction<string>) {
    //   state.loading = true;
    // },
  },
});

export const inverterActions = inverterSlice.actions;

export const selectInverterError = (state: RootState) => state.inverterReducer.error;
export const selectLoading = (state: RootState) => state.inverterReducer.loading;
export const selectInverterInfo = (state: RootState) => state.inverterReducer.currentInverter;
export const selectInverterList = (state: RootState) => state.inverterReducer.inverterList;
export const selectColorList = (state: RootState) => state.inverterReducer.colorList;

const inverterReducer = inverterSlice.reducer;
export default inverterReducer;
